module.exports = __webpack_public_path__ + "static/media/regwiz_127.fbcc6dd6.ico";